import { db } from "../indexedDB";
import store from "../store";
import axiosInstance from "../axiosInstance";
import { fetchAndStoreMyVehicleFuel } from "./myDataService";

const API_URL = process.env.VUE_APP_SERVICE_URL + "/api/vehicles";
const STORE_NAME = "vehicle_fuel_logs";
const MY_DATA_STORE_NAME = "my_vehicle_fuel_logs";

export const fetchVehicleFuel = async (vehicleId) => {
  if (navigator.onLine) {
    const url = API_URL + `/v1/${vehicleId}/fuel/all?is_paginated=false`;
    const params = {};
    const headers = {};
    const method = "get";

    try {
      const response = await axiosInstance({
        method,
        url,
        data: params,
        headers: {
          ...headers,
        },
      });

      if (response.data == null) {
        store.commit("setError", { isError: true, error: "Item not found." });
      } else if (response.data.error) {
        store.commit("setError", { isError: true, error: response.data.error });
      } else {
        const data = response.data.data;
        return data;
      }
    } catch (error) {
      store.commit("setError", { isError: true, error: error });
      console.error(`Failed to fetch ${STORE_NAME}:`, error);
    }
  } else {
    return [];
  }
};

export const addVehicleFuel = async (vehicleId, item, isOthers = false) => {
  if (navigator.onLine) {
    const url = API_URL + `/v1/${vehicleId}/fuel/new`;
    const params = item;
    const headers = {};
    const method = "post";

    try {
      const response = await axiosInstance({
        method,
        url,
        data: params,
        headers: {
          ...headers,
        },
      });

      if (response.data == null) {
        store.commit("setError", { isError: true, error: "Item not found." });
      } else if (response.data.error) {
        store.commit("setError", { isError: true, error: response.data.error });
      } else {
        if (!isOthers) {
          await fetchAndStoreMyVehicleFuel();
        }
        store.commit("setError", {
          isError: false,
          error: response.data.message,
        });
        return "success";
      }
    } catch (error) {
      store.commit("setError", {
        isError: true,
        error: `Failed to add ${STORE_NAME}: ${error}`,
      });
      console.error(`Failed to add ${STORE_NAME}:`, error);
    }
  } else if (!isOthers) {
    // Store the change for later
    await db.addOfflineChange({
      type: "addMyVehicleFuel",
      MY_DATA_STORE_NAME,
      item,
    });
    await db.addItem(MY_DATA_STORE_NAME, item);
    store.commit("setError", {
      isError: false,
      error: `Your changes are offline.`,
    });
    return "success";
  } else {
    store.commit("setError", {
      isError: true,
      error: `Cannot create fuel history record offline.`,
    });
  }
};

export const editVehicleFuel = async (vehicleId, item, isOthers = false) => {
  if (navigator.onLine) {
    const url = API_URL + `/v1/${vehicleId}/fuel/edit`;
    const params = item;
    const headers = {};
    const method = "post";

    try {
      const response = await axiosInstance({
        method,
        url,
        data: params,
        headers: {
          ...headers,
        },
      });

      if (response.data == null) {
        store.commit("setError", { isError: true, error: "Item not found." });
      } else if (response.data.error) {
        store.commit("setError", { isError: true, error: response.data.error });
      } else {
        if (!isOthers) {
          await fetchAndStoreMyVehicleFuel();
        }
        store.commit("setError", {
          isError: false,
          error: response.data.message,
        });
        return "success";
      }
    } catch (error) {
      store.commit("setError", {
        isError: true,
        error: `Failed to edit ${STORE_NAME}: ${error}`,
      });
      console.error(`Failed to edit ${STORE_NAME}:`, error);
    }
  } else if (!isOthers) {
    // Store the change for later
    await db.addOfflineChange({
      type: "editMyVehicleFuel",
      STORE_NAME,
      item,
    });
    await db.editItem(STORE_NAME, item.uuid, item);
    store.commit("setError", {
      isError: false,
      error: `Your changes are offline.`,
    });
    return "success";
  } else {
    store.commit("setError", {
      isError: true,
      error: `Cannot create fuel history record offline.`,
    });
  }
};

export const deleteVehicleFuel = async (vehicleId, item, isOthers = false) => {
  if (navigator.onLine) {
    const url = API_URL + `/v1/${vehicleId}/fuel/delete`;
    const params = item;
    const headers = {};
    const method = "post";

    try {
      const response = await axiosInstance({
        method,
        url,
        data: params,
        headers: {
          ...headers,
        },
      });

      if (response.data == null) {
        store.commit("setError", { isError: true, error: "Item not found." });
      } else if (response.data.error) {
        store.commit("setError", { isError: true, error: response.data.error });
      } else {
        if (!isOthers) {
          await fetchAndStoreMyVehicleFuel();
        }
        store.commit("setError", {
          isError: false,
          error: response.data.message,
        });
        return "success";
      }
    } catch (error) {
      store.commit("setError", {
        isError: true,
        error: `Failed to delete ${STORE_NAME}: ${error}`,
      });
      console.error(`Failed to delete ${STORE_NAME}:`, error);
    }
  } else if (!isOthers) {
    // Store the change for later
    await db.addOfflineChange({
      type: "deleteMyVehicleFuel",
      MY_DATA_STORE_NAME,
      item,
    });
    await db.deleteItem(MY_DATA_STORE_NAME, item.uuid);
    store.commit("setError", {
      isError: false,
      error: `Your changes are offline.`,
    });
    return "success";
  } else {
    store.commit("setError", {
      isError: true,
      error: `Cannot delete fuel history offline.`,
    });
  }
};

export const syncOfflineVehicleFuelChanges = async () => {
  if (!navigator.onLine) return;

  const offlineChanges = await db.getOfflineChanges();
  for (const change of offlineChanges) {
    store.commit("startSync", true);
    try {
      if (change.type === "addMyVehicleFuel") {
        await addVehicleFuel(change.item.vehicle_uuid, change.item);
        await db.deleteOfflineChange(change.iDBkey);
      }
      if (change.type === "editMyVehicleFuel") {
        await editVehicleFuel(change.item.vehicle_uuid, change.item);
        await db.deleteOfflineChange(change.iDBkey);
      }
      if (change.type === "deleteMyVehicleFuel") {
        await deleteVehicleFuel(change.item.vehicle_uuid, change.item);
        await db.deleteOfflineChange(change.iDBkey);
      }
      store.dispatch("endSync");
    } catch (error) {
      console.error(`Failed to sync change for ${change.STORE_NAME}:`, error);
    }
  }
};
